/**
 * Cart add-to-cart popup functionality
 * Displays a modal popup when products are added to cart with product details
 * Handles error states, product recommendations, and upsell functionality
 */
class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.notification = document.getElementById('modal-cart-add-popup');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

  }

  /**
   * open
   * @param {Boolean} hasError 
   */
  open(hasError = false) {
    const errorClass = 'cart-add-popup--has-error';
    if (hasError) {
      this.notification.classList.add(errorClass);
    } else {
      this.notification.classList.remove(errorClass);
    }

    this.notification.classList.add('animate', 'active');
    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });
    document.body.addEventListener('click', this.onBodyClick);
    this.querySelectorAll('.cart-add-popup__links-continue').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  /**
   * close
   */
  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus(this.activeElement);
  }

  /**
   * renderContents
   * @param {Object} parsedState 
   */
  renderContents(parsedState, upsell = false) {
    this.productId = parsedState.id;

      if (upsell) {
        this.getSectionsToRenderAfterUpsell().forEach((section => {
          document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        }));
      }
      else {
        this.recommendationProductId = parsedState.recommendationProductId;
        this.getSectionsToRender().forEach((section => {
          document.getElementById(section.id).innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        }));
      // this.open();
    }
    this.open();

  }

  /**
   * renderQuantityError
   * @param {String} inventoryQuantity
   */
  renderQuantityError(inventoryQuantity) {
    const errorMessageElem = this.notification.querySelector('[data-cart-add-popup-error-message]');
    const inventoryQty = parseInt(inventoryQuantity) || 0;

    errorMessageElem.innerText = window.cartStrings.quantityError.replace('[quantity]', inventoryQty);
    
    this.open(true);
  }

  /**
   * getSectionsToRender
   * @returns {Array} Sections to render
   */
  getSectionsToRender() {
    return [
      {
        id: 'cart-add-popup-product',
        selector: `#cart-add-popup-product-${this.productId}`,
      },      
      {
        id: 'product-recommendations-inline',
        selector: `[data-recommended-products-inline]`,
      },
      {
        id: 'cart-icon-bubble',
        selector: '[data-cart-icon-bubble]',
      },
    ];
  }  
  
  /**
   * getSectionsToRender
   * @returns {Array} Sections to render
   */
  getSectionsToRenderAfterUpsell() {
    return [
      {
        id: 'cart-icon-bubble',
        selector: '[data-cart-icon-bubble]',
      },      
      {
        id: 'cart-add-popup-product',
        selector: `#cart-add-popup-product-${this.productId}`,
      },
    ];
  }

  /**
   * getSectionInnerHTML
   * @param {String} String that contains html
   * @param {String} selector 
   * @returns 
   */
  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  /**
   * handleBodyClick
   * @param {Object} evt 
   */
  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-add-popup') && !target.closest('.modal-header') || target.closest('.close-button')) {
      this.close();
    }
  }

  /**
   * setActiveElement
   * @param {Node} element 
   */
  setActiveElement(element) {
    this.activeElement = element;
  }
}

if (!customElements.get('cart-add-popup')) {
  customElements.define('cart-add-popup', CartNotification);
}
